import { useEffect, useState } from 'react';
import { readError } from '../../app/api';
import { ANALYTICS_PAGE_SIZE, loadSessionEventPage } from './analytics-api';
import { PaginationControls } from './PaginationControls';
import { SessionEventTimeline } from './SessionEventTimeline';
import type { SessionEventPage } from './types';

export function PaginatedSessionEventTimeline(props: {
  environmentId: string;
  sessionId: string;
}): React.JSX.Element {
  const [page, setPage] = useState(1);
  const [result, setResult] = useState<SessionEventPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setPage(1);
  }, [props.environmentId, props.sessionId]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    loadSessionEventPage(props.environmentId, props.sessionId, page, ANALYTICS_PAGE_SIZE)
      .then((response) => {
        if (!active) return;
        setResult(response);
        if (response.pagination.page !== page) setPage(response.pagination.page);
      })
      .catch((caught: unknown) => {
        if (active) setError(readError(caught));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [page, props.environmentId, props.sessionId]);

  if (error !== '') {
    return <div className="error-banner">{error}</div>;
  }
  if (result === null && loading) {
    return <div className="empty">Loading session events…</div>;
  }
  if (result === null || result.events.length === 0) {
    return <div className="empty">This session has no recorded events.</div>;
  }
  return (
    <>
      <SessionEventTimeline events={result.events} />
      <PaginationControls pagination={result.pagination} disabled={loading} onPageChange={setPage} />
    </>
  );
}
